import { render } from "./StudentsData.vue?vue&type=template&id=4d607c78&scoped=true"
import script from "./StudentsData.vue?vue&type=script&lang=js"
export * from "./StudentsData.vue?vue&type=script&lang=js"

import "./StudentsData.vue?vue&type=style&index=0&id=4d607c78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d607c78"]])

export default __exports__